export const translateClientField = (clientField: string): string => {
    let valToReturn = '';
    switch (clientField) {
        case 'name':
            valToReturn = 'Naziv/Ime';
            break;
        case 'shortName':
            valToReturn = 'Skraćeni naziv/ime';
            break;
        case 'phone':
            valToReturn = 'Telefon';
            break;
        case 'address':
            valToReturn = 'Adresa';
            break;
        case 'state':
            valToReturn = 'Država';
            break;
        case 'city':
            valToReturn = 'Grad';
            break;
        case 'ucin':
            valToReturn = 'JMBG/Matični broj firme';
            break;
        case 'taxId':
            valToReturn = 'PIB/JIB/...';
            break;
        case 'email':
            valToReturn = 'Email';
            break;
        default:
            break;
    }

    return valToReturn;
};
